"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SENSITIVE_KEYS = void 0;

/**
 * A list of keys which should be considered sensitive and should not be logged.
 * They are normalised to lowercase so when comparing keys they should also be
 * normalised beforehand, i.e. in lowercase and with any hypens or underscores
 * removed.
 */
var SENSITIVE_KEYS =
/** @type {const} */
['username', 'firstname', 'lastname', 'screenname', 'phone', 'phonenumber', 'mobile', 'mobilenumber', 'telephone', 'telephonenumber', 'email', 'useremail', 'address', 'town', 'city', 'county', 'state', 'country', 'postcode', 'zipcode', 'accesstoken', 'refreshtoken', 'idtoken'];
exports.SENSITIVE_KEYS = SENSITIVE_KEYS;